"use strict";
function asciiToArray(string) {
    return string.split('');
}
module.exports = asciiToArray;
//# sourceMappingURL=_asciiToArray.js.map